'use strict';

exports.__esModule = true;

var _orderBy2 = require('lodash/orderBy');

var _orderBy3 = _interopRequireDefault(_orderBy2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _starRating = require('star-rating');

var _reactRouter = require('react-router');

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

require('../../src/styles/external.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SpecialistListSection = function SpecialistListSection(props) {
    var practiceId = props.practiceId,
        specialists = props.specialists,
        topLevelSpecialties = props.topLevelSpecialties,
        onSelectSpecialty = props.onSelectSpecialty;

    return _react2.default.createElement(
        'div',
        { className: _style2.default.specialistListSection },
        _react2.default.createElement(
            'h2',
            null,
            'Specialists'
        ),
        _react2.default.createElement(
            'div',
            { className: _style2.default.specialistListSectionBody },
            _react2.default.createElement(
                'div',
                { className: _style2.default.specialistListHeader },
                _react2.default.createElement(
                    'div',
                    { className: 'select-container form-control' },
                    _react2.default.createElement(
                        'select',
                        { onChange: function onChange(event) {
                                return onSelectSpecialty(event.target.value);
                            } },
                        _react2.default.createElement(
                            'option',
                            { value: '' },
                            'All Specialties'
                        ),
                        topLevelSpecialties && topLevelSpecialties.map(function (specialty, index) {
                            return _react2.default.createElement(
                                'option',
                                { key: index, value: specialty },
                                specialty
                            );
                        })
                    )
                )
            ),
            _react2.default.createElement(
                'ul',
                { className: _style2.default.specialistList },
                specialists && (0, _orderBy3.default)(specialists.filter(function (specialist) {
                    return specialist.status === 'approved';
                }), ['hasBooking', 'hasRequestAppointment', 'firstname', 'lastname'], ['desc', 'desc', 'asc', 'asc']).map(function (specialist, index) {
                    if (specialist) {
                        return _react2.default.createElement(
                            'li',
                            { key: index, className: _style2.default.specialistListItem },
                            _react2.default.createElement(
                                'div',
                                { className: _style2.default.imageContainer },
                                _react2.default.createElement('img', { className: _style2.default.profile_image, src: specialist.profileImage || specialist.specialtyIconUri })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _style2.default.textContainer },
                                _react2.default.createElement(
                                    _reactRouter.Link,
                                    { to: '/specialist/' + specialist.uriId + '/?practice=' + practiceId },
                                    _react2.default.createElement(
                                        'div',
                                        { className: _style2.default.specialistName },
                                        specialist.title + ' ' + specialist.firstname + ' ' + specialist.lastname
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: _style2.default.specialistSpecialty },
                                    specialist.topLevelSpecialty
                                ),
                                specialist && specialist.subspecialties && specialist.subspecialties.length >= 1 && _react2.default.createElement(
                                    'div',
                                    { className: _style2.default.specialistSubspecialty },
                                    specialist.subspecialties.length === 1 ? 'Subspecialty: ' : 'Subspecialties: ',
                                    _react2.default.createElement(
                                        'span',
                                        { className: _style2.default.subspecialtiesList },
                                        specialist.subspecialties.join(', ')
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: _style2.default.stars },
                                    _react2.default.createElement(_starRating.StarRating, { averageRating: specialist.averageRating })
                                )
                            ),
                            specialist.hasBooking ? _react2.default.createElement(
                                'div',
                                { className: _style2.default.buttonContainer },
                                _react2.default.createElement(
                                    _reactRouter.Link,
                                    { to: '/specialist/' + specialist.uriId + '/?practice=' + practiceId },
                                    _react2.default.createElement(
                                        'button',
                                        { className: 'btn solid' },
                                        'Book'
                                    )
                                )
                            ) : null
                        );
                    }
                })
            )
        )
    );
};

SpecialistListSection.propTypes = {
    practiceId: require('react').PropTypes.string,
    specialists: require('react').PropTypes.arrayOf(require('react').PropTypes.shape({
        uriId: require('react').PropTypes.string,
        title: require('react').PropTypes.string,
        firstname: require('react').PropTypes.string,
        lastname: require('react').PropTypes.string,
        profileImage: require('react').PropTypes.string,
        averageRating: require('react').PropTypes.number,
        hasBooking: require('react').PropTypes.bool,
        topLevelSpecialty: require('react').PropTypes.string,
        specialtyIconUri: require('react').PropTypes.string,
        subspecialties: require('react').PropTypes.arrayOf(require('react').PropTypes.string)
    })),
    topLevelSpecialties: require('react').PropTypes.arrayOf(require('react').PropTypes.string),
    onSelectSpecialty: require('react').PropTypes.func
};
SpecialistListSection.displayName = 'SpecialistListSection';

SpecialistListSection.defaultProps = {};

exports.default = (0, _reactIntl.injectIntl)(SpecialistListSection);


// WEBPACK FOOTER //
// ./components/profile-right-section/lib/components/specialist-list-section.js